<div class="modal-body" align="center">
  <div class="row row-margin text-center">
    <img
      src="assets/images/pages/create-success.png"
      alt="Operación exitosa"
    />
  </div>
  <div class="row row-margin">
    <h4 class="secondary">
      <b>{{ getMessage() }} </b><b class="primary">exitosamente </b><b>con los siguientes datos</b>
    </h4>  
  </div>
    <div class="row row-margin">
      <div class="col-md-6 col-table left">
        <div class="row text-left first">
          <div class="col-md-6">
            <b>Banco emisor</b>
          </div>
          <div class="col-md-6">
            {{ receipt.issuingBank | titlecase }}
          </div>
        </div>
        <div class="row text-left">
          <div class="col-md-6">
            <b>Nº de cuenta banco emisor</b>
          </div>
          <div class="col-md-6">
            {{ receipt.issuingBankNumber }}
          </div>
        </div>
        <div class="row text-left">
          <div class="col-md-6">
            <b>Banco receptor</b>
          </div>
          <div class="col-md-6">
            {{ receipt.receivingBank | titlecase }}
          </div>
        </div>
        <div class="row text-left last">
          <div class="col-md-6">
            <b>Fecha transferencia</b>
          </div>
          <div class="col-md-6">
            {{ receipt.transferDate | date: "dd/MM/yyyy" }}
          </div>
        </div>
      </div>
      <div class="col-md-6 col-table">
        <div class="row text-left first">
          <div class="col-md-6">
            <b>Monto</b>
          </div>
          <div class="col-md-6">
            {{ receipt.amount | customCurrency: receipt.currency }}
          </div>
        </div>
        <div class="row text-left">
          <div class="col-md-6">
            <b>Moneda</b>
          </div>
          <div class="col-md-6">
            {{ receipt.currency }}
          </div>
        </div>
        <div class="row text-left last">
          <div class="col-md-6">
            <b>Nº de operación</b>
          </div>
          <div class="col-md-6">
            {{ receipt.operationNumber }}
          </div>
        </div>
      </div>
    </div>
  
    <div class="row text-center">
      <button
        (click)="hide()"
        class="button-continue button-find-label"
      >
        Volver a detalle de solicitud
      </button>
    </div>
  </div>
  